export default __webpack_public_path__ + "static/blog5-c509132bc9d8075a37576d5bb561681e.jpg";